import React from "react";
import { translate } from "../../../utils/useful";

class BalanceSheet extends React.Component {
    render() {
        return (
            <div className="mx-3">
                <div className="flexcc flex-column">
                    <p style={{ fontSize: 12 }}>{translate('test')}</p>
                    <p>{translate('Balance Sheet')}</p>
                    <div className="d-flex align-items-center mt-1">
                        <p style={{ fontSize: 12 }}>{translate('Basis:')}</p>&nbsp;
                        <p style={{ fontSize: 12 }}>{translate('Accrual')}</p>
                    </div>
                    <div className="d-flex align-items-center mt-1">
                        <p style={{ fontSize: 12 }}>{translate('As of')}</p>&nbsp;
                        <p style={{ fontSize: 12 }}>2023/01/07</p>&nbsp;
                        {/* <p style={{ fontSize: 12 }}>To</p>&nbsp;
                        <p style={{ fontSize: 12 }}>2023/01/31</p>&nbsp; */}
                    </div>
                </div>
                <div className="mt-3">
                    <div style={{ display: 'flex', justifyContent: 'flex-end', }}>
                        <p style={{ color: '#408dfb', fontSize: 13 }}>{translate('+ Add Temporary Note')}</p>
                    </div>
                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                <div className="flexcb">
                    <div>
                        <p style={{ fontSize: 14 }}>{translate('Account')}</p>
                    </div>
                    <div>
                        <p style={{ fontSize: 14 }}>{translate('Total')}</p>
                    </div>
                </div>
                <div className="my-1" style={{ borderBottom: '1px solid #dadada' }} />

                <div className="">
                    <div className="mt-2">
                        <p style={{ fontSize: 13, fontWeight: 'bold' }}>{translate('Assets')}</p>
                    </div>
                    <div className="mt-2">
                        <p style={{ fontSize: 13, fontWeight: 'bold' }}>{translate('Current Assets')}</p>
                    </div>
                    <div className="mt-2">
                        <p style={{ fontSize: 13, fontWeight: 'bold' }}>{translate('Cash')}</p>
                    </div>
                    <div className="flexcb mt-2">
                        <div className="mld-3">
                            <p style={{ fontSize: 13, color: '#408dfb' }}>{translate('Petty Cash')}</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13, color: '#408dfb' }}>0.0</p>
                        </div>

                    </div>
                    <div className="flexcb mt-2">
                        <div>
                            <p style={{ fontSize: 13, }}>{translate('Total for Cash')}</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13, }}>0.0</p>
                        </div>

                    </div>

                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />

                <div className="">
                    <div className="flexcb mt-2">
                        <div>
                            <p style={{ fontSize: 13 }}>{translate('Accounts Receivable')}</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13 }}>0.0</p>
                        </div>

                    </div>
                    <div className="mt-2">
                        <p style={{ fontSize: 13, fontWeight: 'bold' }}>{translate('Other current assets')}</p>
                    </div>
                    <div className="flexcb mt-2">
                        <div className="mld-3">
                            <p style={{ fontSize: 13, color: '#408dfb' }}>{translate('Employee Advance')}</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13 }}>0.0</p>
                        </div>

                    </div>
                    <div className="flexcb mt-2">
                        <div className="">
                            <p style={{ fontSize: 13, }}>{translate('Total for Other current assets')}</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13 }}>0.0</p>
                        </div>

                    </div>

                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                <div className="flexcb mt-2">
                    <div className="">
                        <p style={{ fontSize: 13, }}>{translate('Total for Current Assets')}</p>
                    </div>
                    <div>
                        <p style={{ fontSize: 13 }}>0.0</p>
                    </div>

                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                <div className="flexcb mt-2">
                    <div className="">
                        <p style={{ fontSize: 13, }}>{translate('Total for Assets')}</p>
                    </div>
                    <div>
                        <p style={{ fontSize: 13 }}>0.0</p>
                    </div>

                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                <div className="">
                    <div className="mt-2">
                        <p style={{ fontSize: 13, fontWeight: 'bold' }}>{translate('Liabilities & Equities')}</p>
                    </div>
                    <div className="mt-2">
                        <p style={{ fontSize: 13, fontWeight: 'bold' }}>{translate('Equities')}</p>
                    </div>
                    <div className="flexcb mt-2">
                        <div className="mld-3">
                            <p style={{ fontSize: 13, color: '#408dfb' }}>{translate('Current Year Earnings')}</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13, color: '#408dfb' }}>0.0</p>
                        </div>

                    </div>
                    <div className="flexcb mt-2">
                        <div>
                            <p style={{ fontSize: 13, }}>{translate('Total for Equities')}</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13, }}>0.0</p>
                        </div>

                    </div>

                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />

                <div className="flexcb mt-2">
                    <div>
                        <p style={{ fontSize: 13, }}>{translate('Total for Liabilities & Equities')}</p>
                    </div>
                    <div>
                        <p style={{ fontSize: 13, }}>0.0</p>
                    </div>

                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                {/* <div className="flexcb">
                    <div></div>
                    <div><p style={{ fontSize: 13, fontWeight: 'bold' }}>Net Change in cash	</p></div>
                    <div><p style={{ fontSize: 13 }}>0.0</p></div>
                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                <div className="flexcb">
                    <div></div>
                    <div><p style={{ fontSize: 13, fontWeight: 'bold' }}>Ending Cash Balance	</p></div>
                    <div><p style={{ fontSize: 13 }}>0.0</p></div>
                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} /> */}

            </div>
        )
    }
}


export default BalanceSheet;